module.exports = __webpack_public_path__ + "static/forte_entire_page-857f58c7c2166e86e6357fce261a4e62.jpg";